import { render } from "./SessionsPage.vue?vue&type=template&id=8c57ad70&ts=true"
import script from "./SessionsPage.vue?vue&type=script&lang=ts"
export * from "./SessionsPage.vue?vue&type=script&lang=ts"

import "./SessionsPage.vue?vue&type=style&index=0&id=8c57ad70&lang=css"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__